"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const RoleHelper_1 = tslib_1.__importDefault(require("./RoleHelper"));
const EducationCodes_1 = tslib_1.__importDefault(require("./EducationCodes"));
/*
 * Potentially relevant education codes:
 *
 * 4498 Optiker
 * 5151 Fysioterapeut
 * 5152 Social- og sundhedsass.
 * 5153 Ergoterapeut
 * 5155 Fodterapeut
 * 5158 Radiograf
 * 5159 Bioanalytiker
 * 5166 Sygeplejerske
 * 5175 Jordemoder
 * 5265 Kiropraktor
 * 5431 Tandplejer
 * 5432 Klinisk tandteknik
 * 5433 Tandlæge
 * 5451 Klinisk diætist
 * 7170 Læge
 * 9495 Bandagist
 */
class EducationHelper {
    static fromCode(code) {
        const education = EducationHelper.allEducations[code];
        if (!education) {
            throw new Error("Unexpected education code " + code);
        }
        return education;
    }
    static isHealthcareEducationCode(code) {
        return !!EducationHelper.allEducations[code];
    }
    static getRole(education, asAssistant) {
        return asAssistant ? education.assistantRole : education.role;
    }
    static createEducation(code, title, role, assistantRole) {
        if (!EducationHelper.allEducations) {
            EducationHelper.allEducations = {};
        }
        const education = {
            assistantRole,
            code,
            role,
            title
        };
        EducationHelper.allEducations[code] = education;
        return education;
    }
}
// IMPORTANT: only include educations that should be recognized and used in the user context
// See method isHealthcareEducationCode(int).
EducationHelper.SOSU_HELPER = EducationHelper.createEducation(EducationCodes_1.default.SOSU_HELPER, "social- og sundhedshj.", RoleHelper_1.default.SosuHelp, undefined);
EducationHelper.SOSU_ASSIST = EducationHelper.createEducation(EducationCodes_1.default.SOSU_ASSIST, "social- og sundhedsass.", RoleHelper_1.default.SosuAssist, RoleHelper_1.default.AssistantForSosuAssist);
EducationHelper.NURSE = EducationHelper.createEducation(EducationCodes_1.default.NURSE, "sygeplejerske", RoleHelper_1.default.Nurse, RoleHelper_1.default.AssistantForNurse);
EducationHelper.HEALTH_VISITOR = EducationHelper.createEducation(EducationCodes_1.default.HEALTH_VISITOR, "sundhedsplejerske", RoleHelper_1.default.HealthVisitor, undefined);
EducationHelper.MIDWIFE = EducationHelper.createEducation(EducationCodes_1.default.MIDWIFE, "jordemoder", RoleHelper_1.default.Midwife, RoleHelper_1.default.AssistantForMidwife);
EducationHelper.PHARMACONOMIST = EducationHelper.createEducation(EducationCodes_1.default.PHARMACONOMIST, "farmakonom", RoleHelper_1.default.Pharmaconomist, undefined);
EducationHelper.PHARMACIST = EducationHelper.createEducation(EducationCodes_1.default.PHARMACIST, "farmaceut", RoleHelper_1.default.Pharmacist, RoleHelper_1.default.PharmacyEmployee); // c.pharm.
// PHARMACIST_PHD(5427, "farmaceut", PharmacistRole, null), // ph.d.
EducationHelper.PHARMACIST_BACH = EducationHelper.createEducation(EducationCodes_1.default.PHARMACIST_BACH, "farmaceut", RoleHelper_1.default.Pharmacist, undefined); // bach.
EducationHelper.DENTIST = EducationHelper.createEducation(EducationCodes_1.default.DENTIST, "tandlæge", RoleHelper_1.default.Dentist, RoleHelper_1.default.AssistantForDentist);
EducationHelper.DOCTOR = EducationHelper.createEducation(EducationCodes_1.default.DOCTOR, "læge", RoleHelper_1.default.Doctor, RoleHelper_1.default.AssistantForDoctor);
EducationHelper.PHARMACIST_WITH_PRESCRIPTION_RIGHTS = EducationHelper.createEducation(EducationCodes_1.default.PHARMACIST_WITH_PRESCRIPTION_RIGHTS, "behandlerfarmaceut", RoleHelper_1.default.PharmacistWithPrescriptionRights);
exports.default = EducationHelper;
//# sourceMappingURL=EducationHelper.js.map